module.exports = __webpack_public_path__ + "img/coinspaid.532ab318.svg";